// extracted by mini-css-extract-plugin
module.exports = {"base":"faqs_base__iDIhU","graphSVG":"faqs_graphSVG__4sMqc","cards":"faqs_cards__5QDo9"};